/**
 * @file abeEducationOutcomes.js
 * @author Jake Stark
 * @desc abeEducationOutcomes report plugin

*/

/**
 * @module abeEducationOutcomes
 * @desc abeEducationOutcomes report plugin
 */

define('plugins/abeEducationOutcomes',["underscore", "models",
        "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/abeEducationOutcomes_enrollees.html", "text!plugins/templates/abeEducationOutcomes_pane2_HSGradStatus.html", "text!plugins/templates/abeEducationOutcomes_pane2_timeSinceK12Activity.html", "text!plugins/templates/abeEducationOutcomes_pane2_empoloyedInMN.html", "text!plugins/templates/abeEducationOutcomes_pane2_empoloyedWhileInABE.html", "text!plugins/templates/abeEducationOutcomes_pane2_incarceratedInMN.html", "text!plugins/templates/abeEducationOutcomes_pane2_postSecondaryActivity.html", "text!plugins/templates/abeEducationOutcomes_pane2_typeOfPSEnrollment.html", "text!plugins/templates/abeEducationOutcomes_pane3_gender.html", "text!plugins/templates/abeEducationOutcomes_pane3_race.html", "text!plugins/templates/abeEducationOutcomes_pane3_ethnicityHispanic.html", "text!plugins/templates/abeEducationOutcomes_pane3_eageAtEntry.html", "text!plugins/templates/abeEducationOutcomes_pane3_enteringFunctionalLevel.html", "text!plugins/templates/abeEducationOutcomes_pane3_enteringFunctionalLevelEsl.html", "text!plugins/templates/abeEducationOutcomes_pane3_enteringFunctionalLevelOther.html", "text!plugins/templates/abeEducationOutcomes_pane4_empoloyedAfterABE.html", "text!plugins/templates/abeEducationOutcomes_pane4_incarceratedAfterABE.html", "text!plugins/templates/abeEducationOutcomes_pane4_postSecondaryActivity.html", "text!plugins/templates/abeEducationOutcomes_pane4_typeOfPSEnrollment.html", "text!plugins/templates/abeEducationOutcomes_pane5_typeOfDegreeEarned.html", "text!plugins/templates/abeEducationOutcomes_pane5_gradsStartingCollegePersistince.html", "text!plugins/templates/abeEducationOutcomes_pane5_employment.html", "text!plugins/templates/abeEducationOutcomes_pane5_incarceratedInMn.html", "cardboard/pluginPieces"
    ],
    function (_, SLEDSModels,
        CardboardModels, CardboardCollections, Util, enrolleesTemplate, hsGradStatusTemplate, timeSinceK12ActivityTemplate, empoloyedInMNTemplate, pane2_empoloyedWhileInABE, pane2_incarceratedInMN, pane2_postSecondaryActivity, pane2_typeOfPSEnrollment, pane3_gender, pane3_race, pane3_ethnicityHispanic, pane3_eageAtEntry, pane3_enteringFunctionalLevel, pane3_enteringFunctionalLevelEsl, pane3_enteringFunctionalLevelOther, pane4_empoloyedAfterABE, pane4_incarceratedAfterABE, pane4_postSecondaryActivity, pane4_typeOfPSEnrollment, pane5_typeOfDegreeEarned, pane5_gradsStartingCollegePersistince, pane5_employment, pane5_incarceratedInMn, PluginPieces) {

        console.log("MODULE: abeEducationOutcomes");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["abeEducationOutcomesCOHORTID"],
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "ABE Enrollees",
                    openByDefault: true,
                    explanationText: "<p>This report shows the number of Minnesota Adult Basic Education students who generated contact hours during the year (from May 1- April 30).</p><p>Enrollees are adult education students with any contact hours during the year. Participants are adult education students with 12 or more contact hours during the year.</p>",

                    views: [{
                        type: "template",
                        template: enrolleesTemplate,
                        dataSourceName: "data"
                    }]
                },
                {
                    title: "Activity Prior to ABE Entry",
                    openByDefault: false,
                    explanationText: "These reports show student activity Prior to ABE entry.",
                    views: [{
                            type: "template",
                            template: "<h5>High School Graduation Status </h5><p>This report shows the number of ABE learners who have or have not earned a recognized high school diploma or recognized high school equivalency diploma prior to the selected year of participation in ABE programming.</p><p>Please note: High school diplomas earned in other countries may not be recognized or included as graduates in this data.</p>",

                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane2_HSGradStatus.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },
                                {
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                }

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: hsGradStatusTemplate,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5> Time Since Last Reported Kindergarten to 12th Grade Participation</h5><p>This report indicates the number of years since last reported K-12 participation for ABE students during the selected year. This data combines ABE data and MDE K-12 Enrollment and will only include K12 participation from Minnesota schools.</p>",

                        },
                        {
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane2_timeSinceK12Activity.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: timeSinceK12ActivityTemplate,
                            dataSourceName: "data"
                        },

                        {
                            type: "template",
                            template: "<h5>Employed in Minnesota Prior to ABE</h5><p>This report indicates the number and percentage of ABE students during the selected time period who were employed in the state of Minnesota before the selected year of participation in ABE programming. This report combines ABE data and data from the Minnesota Department of Employment and Economic Development (DEED).</p>",

                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane2_empoloyedInMN.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: empoloyedInMNTemplate,
                            dataSourceName: "data"
                        },

                        {
                            type: "template",
                            template: "<h5>Incarcerated in Minnesota Prior to ABE</h5><p>This report indicates the number and percentage of ABE students, during the selected time period, who had been incarcerated in a state Department of Corrections (DOC) facility prior to the selected year of participation in ABE. This does not include individuals who had been incarcerated in county jails.</p>",

                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane2_incarceratedInMN.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane2_incarceratedInMN,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Postsecondary Activity Prior to ABE</h5><p>This report shows the number of ABE students who had enrolled in postsecondary prior to the selected year of participation in ABE. This report combines data from ABE and from Office of Higher Education Postsecondary Enrollment and will only include enrollment at Minnesota postsecondary institutions.</p>",

                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane2_postSecondaryActivity.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane2_postSecondaryActivity,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Award Sought in Postsecondary Enrollment</h5><p>This report indicates the type of credential an individual sought prior to the selected year of participation in ABE for those that were enrolled in a Postsecondary program in Minnesota prior to enrolling in ABE. (If they were not enrolled in a Postsecondary program in Minnesota, they are not counted in the data or in the tables.) This report combines data from ABE and from Office of Higher Education Postsecondary Enrollment and will only include Postsecondary enrollment from Minnesota institutions. Please note that this report shows Postsecondary enrollment, not Postsecondary completion.</p>",

                        },
                        {
                            type: "template",
                            template: pane2_typeOfPSEnrollment,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Employed in Minnesota While Participating in ABE</h5><p>This report shows the number and percent of graduates who enrolled in college in the fall after graduation and those who did not attend college, but instead were found working in Minnesota. Graduates could be enrolled in college in Minnesota or in another state. Employed graduates are those found working in Minnesota one full-year after high school graduation. Graduates not found to be enrolled or working in Minnesota are included in the unknown count. These students may be working in another state, enlisted in military service, be self-employed or working in other organizations not subject to state reporting, or not engaged in the labor force.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane2_empoloyedWhileInABE.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane2_empoloyedWhileInABE,
                            dataSourceName: "data"
                        },
                    ]
                },
                {
                    title: "Demographics",
                    explanationText: "These reports show the number and percentage of ABE participants for the selected year by reported gender, race, ethnicity and age.",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>Gender</h5><p>This report shows the number and percent of ABE participants for the selected year by reported gender.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_gender.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_gender,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Race/Ethnicity</h5><p>This report shows the number and percent of students by reported race/ethnicity, using federal definitions or categories of race and ethnicity.</p>"
                        },

                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_race.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_race,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Hispanic Ethnicity</h5><p>This report shows the number and percentage of ABE students during the selected time period who identified as Hispanic.</p>"
                        },

                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_ethnicityHispanic.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_ethnicityHispanic,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Age at ABE Program Entry</h5><p>This report shows the number and percent of students by age at time of enrollment in the year selected.</p><p>Please note: In 2015, the minimum age for ABE eligibility raised from 16 to 17 due to state statute increasing the compulsory age of attendance in K-12 education.</p>"
                        },

                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_eageAtEntry.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_eageAtEntry,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Entering Educational Functioning Level - ABE Levels</h5><p>This report indicates the number and percentage of participants who were placed in one of the six ABE educational functioning levels when entering the ABE program. The levels are defined by the U.S. Department of Education based on student scores in federally-approved standardized assessments. This data does not include students placed in ESL levels.</p>"
                        },

                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_enteringFunctionalLevel.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_enteringFunctionalLevel,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Entering Educational Functioning Level - ESL Levels</h5><p>This report indicates the number and percentage of participants who were placed in one of the six ESL educational functioning levels when entering the ABE program. The levels are defined by the U.S. Department of Education based on student scores in federally-approved standardized assessments. This data does not include students placed in ABE levels.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_enteringFunctionalLevelESL.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_enteringFunctionalLevelEsl,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Entering Educational Functioning Level - No Level Assigned</h5><p>This report indicates the number and percentage of participants who were not placed in one of the twelve ABE/ESL educational functioning levels when entering the ABE program.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane3_enteringFunctionalLevelOther.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane3_enteringFunctionalLevelOther,
                            dataSourceName: "data"
                        }

                    ]
                },
                {
                    title: "Post-ABE Activity",
                    explanationText: "These reports show student activity after exiting ABE.",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>Employed in Minnesota after Exiting ABE</h5><p>This report shows the number and percentage of students that were employed two years following the end of the selected year of participation. This data combines ABE data and data from the Minnesota Department of Employment and Economic Development. Please note: Employment is tracked only if the student was employed in Minnesota or reported their income in Minnesota.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane4_empoloyedAfterABE.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane4_empoloyedAfterABE,
                            dataSourceName: "data"
                        },

                        {
                            type: "template",
                            template: "<h5>Postsecondary Activity (Enrollment)</h5><p>This report shows how many people were enrolled in postsecondary education two years following the end of the selected year of participation. Data is taken from ABE data and data from Office of Higher Education Postsecondary Enrollment and only includes those participating in postsecondary in Minnesota.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane4_postSecondaryActivity.organizations",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "rows",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "label",

                                },

                            ],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane4_postSecondaryActivity,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: pane4_typeOfPSEnrollment,
                            dataSourceName: "data"
                        }
                    ]
                },
                {
                    title: "Long-term Outcomes",
                    explanationText: "These reports show student activity 1 or more years after ABE exit",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>Certificate or Degrees Earned (Highest Credential)</h5><p>This report shows the highest degree/credential earned by participants any time following the end of the selected year of participation in ABE programming.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane5_typeOfDegreeEarned.slices",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "organizations",
                                valuePath: "percent",
                                seriesDisplayNamePath: "label",
                                displayNamePath: "orgName",
                            }],
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane5_typeOfDegreeEarned,
                            dataSourceName: "data"
                        },

                        {
                            type: "template",
                            template: "<h5>Percent of HS Graduates Starting College and Persisting or Graduating as of:</h5><p>This report shows the number and percentage of ABE participants that were high school diploma or high school equivalency diploma earners that both started postsecondary education and either persisted or graduated postsecondary education any time following the end of the selected year of participation in  ABE programming.</p>"
                        },
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "pane5_gradsStartingCollegePersistince.slices",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,

                            // DISPLAY
                            // xAxisLabelPath: "subjects.label",
                            unitString: "%",
                            showLegend: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "organizations",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "label",
                                    displayNamePath: "orgName",
                                },
                                {
                                    dataPath: "organizations",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "label",
                                    displayNamePath: "orgName",
                                },
                                {
                                    dataPath: "organizations",
                                    valuePath: "percent",
                                    seriesDisplayNamePath: "label",
                                    displayNamePath: "orgName",
                                }
                            ]
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            template: pane5_gradsStartingCollegePersistince,
                            dataSourceName: "data"
                        },
                        {
                            type: "template",
                            template: "<h5>Employment</h5><p>This report shows ABE participants (not enrollees) participation in employment following the end of the selected year of participation in ABE. It also includes the average hourly wages and hours worked for the first and fifth quarters after completion of the ABE Program Year. Please note that data in this report is considered preliminary for recent years. This report shows data for Quarters 1-8 after the ABE year selected. Data is loaded to SLEDS 6-12 months after quarter 8 ends. </p>"
                        },
                        {
                            type: "template",
                            template: pane5_employment,
                            dataSourceName: "data"
                        },

                    ]
                },
                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: '<p><a href="/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&amp;IBIF_ex=sledsws_getdata_abeEducationOutcomes.fex&amp;orgId=999999000&amp;orgName=Statewide&amp;groupType=state&amp;abeEducationOutcomesCOHORTID=2020&amp;FUNCTIONAL_LEVEL=FOC_NONE&amp;outputFormat=XLSX" data-role="button" target="_blank" class="ui-link ui-btn ui-shadow ui-corner-all" role="button">Download All Data</a></p><p>Minnesota Adult Basic Education (ABE) is a state-wide system that serves approximately 65,000 adults annually. ABE students are working towards a high school credential, learning English, improving basic skills such as literacy and math, and/or preparing for post-secondary education or employment. ABE is funded with both federal and state funds, and services are delivered through a network of 39 consortia comprising all Minnesota school districts as well as other partners including the correctional system and community-based organizations.</p><p> <a href="https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=prod047119&RevisionSelectionMethod=latestReleased&Rendition=primary">Download web report data</a> for all ABE consortium and ABE years. Please note this file does not include subgroup statistics.</p>'
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_abeEducationOutcomes_programs.fex",

                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_abeEducationOutcomes_cohortid.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },
                filters2: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_abeEducationOutcomes_dropdowns.fex"
                    },
                    enabled: true,
                },

                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_abeEducationOutcomes_buttons.fex",
                    enabled: true,
                    noViewParams: false,
                    isCat: true
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_abeEducationOutcomes.fex",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000
                    },
                    paramMappings: {
                        //   abeEducationOutcomesCOHORTID: "orgId", 
                        COHORTID: "dataYear",
                        orgName: null // skip this
                    },
                    /*     postProcessor: function (data) {
                            // all we need to do is prettify all the org names!

                            var collections = [
                                data.graduates.organizations,
                                data.MCAProficiency.organizations,
                                data.ACT.organizations,
                                data.ACTScale.organizations,
                                data.ACTTrends.data
                            ];

                            _(collections).each(function (collection) {
                                _(collection).each(function (blob) {
                                    blob.orgName = Util.Data.prettifyName(blob.orgName);
                                });
                            });
                        }, */
                    enabled: true,
                    errorConditions: [{
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Sorry, we don't have any data for your selected organization and year."
                        }
                    }]
                }
            }
        };

        return exports;
    });
